import { boolean, defineAction, number, object, string } from '~/prix'
import reverseGeocodingAction from './reverseGeocoding.action.json'

const reverseGeocodingDefinition = defineAction({
  ...reverseGeocodingAction,
  input: object({
    latitude: number(),
    longitude: number(),
  }),
  output: object({
    streetId: number(),
    streetName: string(),
    neighborhoodId: number().isOptional(),
    neighborhoodName: string().isOptional(),
    cityId: number(),
    cityName: string(),
    municipalityId: number(),
    municipalityName: string(),
    microRegionId: number(),
    microRegionName: string(),
    mesoRegionId: number(),
    mesoRegionName: string(),
    stateId: number(),
    stateName: string(),
    stateAbbreviation: string().isOptional(),
    macroRegionId: number(),
    macroRegionName: string(),
    approximateNumber: number().isOptional(),
    approximateNumberIsEstimated: boolean(),
    quality: string(),
  }),
})

export default reverseGeocodingDefinition
